import { apiClient } from '@/api/client';
import { API_ATTACHMENTS } from '@/api/endpoints';
import { triggerDownload } from '@/utils/file';
import { joinPath } from '@/utils/global';

const REVOKE_DELAY_MS = 1000;

export const downloadAttachment = async (
  attachmentId: string,
  name: string,
): Promise<void> => {
  const response = await apiClient.get<Blob>(
    joinPath(API_ATTACHMENTS, attachmentId),
    { responseType: 'blob' },
  );
  const blobUrl = URL.createObjectURL(response.data);

  triggerDownload(blobUrl, name);
  setTimeout(() => URL.revokeObjectURL(blobUrl), REVOKE_DELAY_MS);
};
